module.exports = __webpack_public_path__ + "media/apps/badges-app-store-a300db8a.svg";